//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[],[[["type"],"SetAssemblyObjectType",{},1,0],[[],"TentativelyConvert",{},0,0],[["numPhysics","physics"],"GetTentativePhysics",{},0,0],[["numNames"],"GetTentativeAssemblyNames",{R_:{assNames:""}},0,0],[["physics","enable"],"EnableObjectsConversion",{},2,0]],[]];
SPLM.Mechatronics.ConstraintConversionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.ConstraintConversionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.ConstraintConversionBuilder.AssemblyObjectTypes = Object.freeze({
    "Constraint" : "Constraint", "JointAndCoupler" : "JointAndCoupler", "All" : "All"});

export default SPLM;